module.exports = __webpack_public_path__ + "img/weddingRingsMorningGlow-emotion-03.481e494.jpg";